module.exports = __webpack_public_path__ + "static/32965902_10216644888823545_3789507519945113600_n-761f21dd8ce08a3cb54f7a86787ceaf8.jpg";